import React, { Component, Suspense, lazy } from "react";

import PropTypes from "prop-types";

import { BrowserRouter, Switch, Redirect, Route } from "react-router-dom";
import { auth } from "../../firebase";

import Loader from "../Loader";

// Route-level code splitting: each page (and its heavy dependencies such as
// react-player, react-slick and the photocard/quote data) is loaded on demand
// instead of shipping in the initial bundle.
const HomePage = lazy(() => import("../HomePage"));
const AdminPage = lazy(() => import("../AdminPage"));
const UserPage = lazy(() => import("../UserPage"));
const NotFoundPage = lazy(() => import("../NotFoundPage"));
const QuotesScreen = lazy(() => import("../QuotesScreen"));
const PhotocardPage = lazy(() => import("../Photocards/Page"));
const NeoZone = lazy(() => import("../UserPage/NeoZone"));

class Router extends Component {
  render() {
    // Properties
    const { roles, bar } = this.props;
    let { user } = this.props;

    if (!user) {
      try {
        user = auth.currentUser.uid;
      } catch (e) {}
    }

    // Functions
    const { openSnackbar } = this.props;

    return (
      <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
        {bar}

        <Suspense fallback={<Loader />}>
          <Switch>
          <Route path="/" exact>
            <HomePage user={user} openSnackbar={openSnackbar} />
          </Route>

          <Route path="/admin">{user && roles.includes("admin") ? <AdminPage /> : <Redirect to="/" />}</Route>

          <Route path="/quotes/:type">
            <QuotesScreen user={user} openSnackbar={openSnackbar} />
          </Route>

          <Route path="/quotes">
            <QuotesScreen user={user} openSnackbar={openSnackbar} />
          </Route>

          <Route path="/photocards">
            <PhotocardPage userId={user && user.uid} openSnackbar={openSnackbar} />
          </Route>

          <Route path="/user">
            <UserPage userId={user && user.uid} />
          </Route>

          <Route path="/neozone">
            <NeoZone />
          </Route>

            <Route>
              <NotFoundPage />
            </Route>
          </Switch>
        </Suspense>
      </BrowserRouter>
    );
  }
}

Router.propTypes = {
  // Properties
  user: PropTypes.object,
  roles: PropTypes.array.isRequired,
  bar: PropTypes.element,

  // Functions
  openSnackbar: PropTypes.func.isRequired,
};

export default Router;
